/* eslint-disable default-param-last */
import { LOGIN_SUCCESS, LOGIN_ERROR, LOGIN_OUT, LOGIN_2FA_REQUIRED } from '../actions';

const initialState = {
  verifyed: false,
  success: false,
  error: null,
  twoFactorRequired: false,
  email: null,
};

// eslint-disable-next-line func-names
const login = function (state = initialState, action) {
  switch (action.type) {
    case LOGIN_2FA_REQUIRED: {
      return {
        verifyed: true,
        success: false,
        error: null,
        twoFactorRequired: true,
        email: action.payload?.email || null,
      };
    }
    case LOGIN_SUCCESS: {
      return {
        verifyed: true,
        error: null,
        success: true,
        twoFactorRequired: false,
        email: null,
      };
    }
    case LOGIN_ERROR: {
      return {
        verifyed: true,
        success: false,
        error: action.payload,
        twoFactorRequired: false,
        email: state.email,
      };
    }
    case LOGIN_OUT: {
      return {
        verifyed: true,
        success: false,
        error: null,
        twoFactorRequired: false,
        email: null,
      };
    }
    default: {
      return state;
    }
  }
};

export default login;